"use strict";

var _classCallCheck = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/media/rahul/New Volume/IITP/summer/OpenSource/Resume/github/resumeapp/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Absorber = void 0;

var AbsorberSize_1 = require("./AbsorberSize");

var OptionsColor_1 = require("../../../../Options/Classes/OptionsColor");

var Absorber =
/*#__PURE__*/
function () {
  function Absorber() {
    _classCallCheck(this, Absorber);

    this.color = new OptionsColor_1.OptionsColor();
    this.color.value = "#000000";
    this.opacity = 1;
    this.size = new AbsorberSize_1.AbsorberSize();
  }

  _createClass(Absorber, [{
    key: "load",
    value: function load(data) {
      if (data !== undefined) {
        if (data.color !== undefined) {
          this.color = OptionsColor_1.OptionsColor.create(this.color, data.color);
        }

        if (data.opacity !== undefined) {
          this.opacity = data.opacity;
        }

        if (data.position !== undefined) {
          this.position = {
            x: data.position.x,
            y: data.position.y
          };
        }

        if (data.size !== undefined) {
          this.size.load(data.size);
        }
      }
    }
  }]);

  return Absorber;
}();

exports.Absorber = Absorber;